import { ReactElement } from 'react';
import { useRouteLoaderData } from 'react-router-dom';

import { useHirePlanForm } from '../../../../../../contexts/HirePlanFormProvider';
import { useHirePlanForm as useHirePlanFormGdf } from '../../../../../../contexts/HirePlanFormProviderGdf';
import { changePagamento } from '../../../../../../utils/ChangeArrays';
import { Input } from '../../../../../Input';
import { Select } from '../../../../../Select';
import { PaymentBilletForm } from './BilletForm';

export function PaymentConsignadoForm(): ReactElement {
  const IndividualData: any = useRouteLoaderData('token');
  const ServerData: any = useRouteLoaderData('token-servidor');
  const ServerPaPData: any = useRouteLoaderData('token-servidorPaP');
  const { register, errors, watch } = useHirePlanForm();
  const {
    register: registerGdf,
    errors: errorsGdf,
    watch: watchGdf,
  } = useHirePlanFormGdf();
  const data = IndividualData || ServerData || ServerPaPData;
  const selectedPaymentType = IndividualData
    ? watch('payment.Type')
    : watchGdf('payment.Type');
  const firstPaymentBillet = IndividualData
    ? watch('payment.firstPaymentBillet')
    : watchGdf('payment.firstPaymentBillet');
  const shouldShowTokenGdf =
    !IndividualData &&
    Number(data?.produtoComercial?.id_prodcomerc) === 711 &&
    Number(selectedPaymentType) === 3;

  changePagamento(data?.formasPagamento);
  return (
    <div
      className="max-[1000px]:flex-col max-[1000px]:items-center min-[748px]:mt-6 min-[748px]:p-6 min-[748px]:pt-4 w-full flex flex-col justify-center"
      style={{ backgroundColor: '#F5F5F5' }}
    >
      <div className="grid grid-cols-3 gap-8">
        <Select
          label="Forma Consignação"
          options={[]}
          optionsFull={data?.formasPagamento || []}
          placeholder="Forma Consignação"
          errorMessage={
            IndividualData
              ? errors.payment?.Type?.message
              : errorsGdf.payment?.Type?.message
          }
          {...(IndividualData
            ? register('payment.Type')
            : registerGdf('payment.Type'))}
        />
        {shouldShowTokenGdf && (
          <Input
            label="TOKEN GDF"
            placeholder="TOKEN GDF"
            errorMessage={errorsGdf.payment?.tokenGdf?.message}
            {...registerGdf('payment.tokenGdf')}
          />
        )}
      </div>
      <div className="flex items-start border bg-primary-container2 rounded-md w-full py-6 px-4 mt-6">
        {/* <InfoIcon className="flex-none items-center min-w-[30px]" /> */}
        <div className="grid grid-cols-1 gap-8">
          <Input
            className="w-[20px] h-[20px]"
            label=""
            type="checkbox"
            errorMessage={
              IndividualData
                ? errors.payment?.firstPaymentBillet?.message
                : errorsGdf.payment?.firstPaymentBillet?.message
            }
            {...(IndividualData
              ? register('payment.firstPaymentBillet')
              : registerGdf('payment.firstPaymentBillet'))}
          />
        </div>
        <span className="flex-1 text-neutral-dark text-sm ml-4">
          <span className="font-bold block">
            Quero pagar a primeira no boleto.
          </span>
          Selecionando essa opção, seu plano ficará disponível assim que a
          OdontoGroup reconhecer o pagamento do seu boleto. As outras
          mensalidades serão cobradas normalmente na conta cadastrada. O boleto
          será enviado para seu email após o envio desse formulário.
        </span>
      </div>
      {firstPaymentBillet && <PaymentBilletForm />}
    </div>
  );
}
